import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormListRequestersService} from '../../../../common/services/requesters-form/requesters-form.service';
import {SubSink} from '@Common/core/utils/subsink';
import {FormListRequesters} from '../../../../common/services/requesters-form/requesters-form.model';
import {PubSubService} from '@Common/core/services';
import {concatMap, finalize} from 'rxjs/operators';
import {FormModel} from '../../../../common/components/form/models';
import {FormulaireService} from '../../../../common/services/formulaire/formulaire.service';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';

/**
 * Modale de création d'une liste sollicités
 * - rattachement du formulaire à cette liste
 * - redirection vers la gestion des membres / sollicityés de cette liste
 */
@Component({
  selector: 'app-requesters-form',
  templateUrl: './requesters-form.component.html',
  styleUrls: ['./requesters-form.component.scss']
})
export class RequestersFormComponent implements OnInit {
  name = '';
  subSink = new SubSink();
  MIN_LENGTH_NAME = 5;
  MAX_LENGTH_NAME = 100;
  constructor(@Inject(MAT_DIALOG_DATA) private data: { form: FormModel},
              private router: Router, private route: ActivatedRoute,
              public dialogRef: MatDialogRef<RequestersFormComponent>,
              private pubSubSvc: PubSubService,
              private snakeSvc: SnackBarToastyService,
              private formListRequestersSvc: FormListRequestersService,
              private formSvc: FormulaireService) {
    console.log(data);
  }

  ngOnInit(): void {
  }
  public createList() {
    if (this.name) {
      const _formList = <FormListRequesters> {
        id: 0,
        name: this.name
      };
      let _formListId = 0;
      this.pubSubSvc.publish('loading', true);
      this.subSink.sink = this.formListRequestersSvc
        .updateOrcreate(_formList)
        .pipe(
          concatMap((_formListCreate: FormListRequesters) => {
            _formListId = _formListCreate.id;
            return this.formSvc.addOrDeleteListRequestersToForm('add', this.data.form.uuid, _formListCreate.id);
          }),
          finalize(() => this.pubSubSvc.publish('loading', false)))
        .subscribe(_ => {
          this.snakeSvc.toasty('Liste sollicités', 'Bien créée, vous allez être redirigé pour gérer ses membres', typeToast.success);
          this._redirectToEditMembers(_formListId);
          this.dialogRef.close();
        });
    }
  }
  private _redirectToEditMembers(list_id) {
    this.router.navigate(['requesters-list/members/edit', list_id, this.data.form.uuid], {relativeTo: this.route.parent});
  }
}
